export const countItems = (array, id) => {
  const filteredArray = array?.filter((item) => item.id === id);
  return filteredArray?.length;
};
